import { BaseTableComponent } from '../../../../shared/tables/base-table/base-table';
import { SchoolResponseDto, UserTypeEnum } from '@whetstoneeducation/hero-common';
import { Component, EventEmitter, Output } from '@angular/core';
import { SchoolsListColumns } from '../schools-list-models/schools-list-columns.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-schools-list-table',
  templateUrl: './schools-list-table.template.html',
  styleUrls: ['./schools-list-table.scss']
})
export class AppSchoolsListTableComponent extends BaseTableComponent<SchoolResponseDto> {
  @Output() toggleDeactivateSchool = new EventEmitter();

  public get displayedColumns() {
    return Object.values(SchoolsListColumns);
  }

  public columnValues = {
    [SchoolsListColumns.REFERENCE_ID]: ['referenceId'],
    [SchoolsListColumns.NAME]: ['name'],
    [SchoolsListColumns.SCHOOL_GROUP]: ['schoolGroupName'],
    [SchoolsListColumns.ACADEMIC_YEAR]: ['currentAcademicYear'],
    [SchoolsListColumns.ACTIVE]: ['deactivateAt']
  };

  public columns = SchoolsListColumns;

  isInternalAdmin = this.isUserType([UserTypeEnum.INTERNAL_ADMIN]);

  constructor(
    readonly router: Router,
  ) {
    super();
  }

  public onToggleDeactivateSchool(school:SchoolResponseDto) {
    this.toggleDeactivateSchool.emit(school);
  }

  public async viewSchool(school) {
    await this.router.navigate(['schools', school.id]);
  }
}
